import { useEffect } from 'react';
import { useNavigate } from 'react-router';

export default function LandingRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('projects', { replace: true });
  }, [navigate]);
  return null;
}
